import moment from 'moment'
import Model from './interface/Model'
import Api from './Api'
import ModelWithFiles from './interface/ModelWithFiles'
import { buildFormData } from './interface/Common'

export default class AudienceSegmentsModule extends ModelWithFiles {
  public api_settings = {
    save_mode: 'post',
    paths: {
      singular: 'audience_segment' as string | null,
      plural: 'audience_segments' as string | null,
    },
  }

  public id: any = null

  public unique_key: any = ''

  public name: string = ''

  public segment_name: string = ''

  public description: string = ''

  public distribution_id: string | null = null

  public segment_id: string | null = null

  public segment_key: string = ''

  public segment_value: string = ''

  public source: string = ''

  public provider: string = ''

  public restrictions: string = ''

  public permitted_advertisers: any = []

  public cost: number = 0

  public custom: boolean = false

  public third_party: boolean = false

  public status: string = 'active'

  public agency_id: string | null = null

  public advertiser_id: string | null = null

  public tenant_id: any = null

  public central_id: number | null = null

  public created_at: string | null = null

  public updated_at: string | null = null

  public get formatedDates() {
    // use moment and return created at
    return {
      created_at: this.created_at ? moment(this.created_at).format('YYYY-MM-DD') : null,
      updated_at: this.updated_at ? moment(this.updated_at).format('YYYY-MM-DD') : null,
    }
  }

  public static async getMarketData(ctx: any) {
    const api = new Api()
    return await api.get('audience_segments/data_market', ctx).then((response: any) => {
      console.log('response', response)
      return {
        records: response.data.result.records,
        data: response.data.result.data_market,
      }
    })
  }

  public static async buySegmnents(ids: any) {
    const api = new Api()
    return await api
      .post('audience_segments/data_market_order', { ids })
      .then((response: any) => response)
  }

  public async importLiverampCatalog() {
    const formData = new FormData()
    buildFormData(formData, {
      model_files_meta: this.model_files_meta,
      model_files_binary: this.model_files_binary,
      instance_id: this.instance_id,
    })
    const api = new Api()
    return await api.post('import-liveramp-catalog', formData).then((response: any) => response)
  }
}
